import script from "./ComponentWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentWidget.vue?vue&type=script&setup=true&lang=js"

import "./ComponentWidget.vue?vue&type=style&index=0&id=64679474&lang=css"

const __exports__ = script;

export default __exports__